import React, { useContext } from 'react';

import { media } from 'context';

import Layout from './Layout';
import PillButton from './PillButton';
import Text from './Text';

interface Props {
  heading?: string | null;
  bodyText: string;
  buttonText: string;
  onButtonClick: () => void;
}

const TenantAdminHelperCtaCard: React.FC<Props> = ({ heading, bodyText, buttonText, onButtonClick }) => {
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Layout
        color="gray-25"
        borderRadius={16}
        direction="column"
        gap={16}
        paddingX={24}
        paddingY={16}
        marginBottom={24}
      >
        <Layout direction="column" gap={4}>
          {heading && (
            <Text size="body-md" semibold>
              {heading}
            </Text>
          )}
          <Text size="body-sm" color="gray-600">
            {bodyText}
          </Text>
        </Layout>
        <PillButton type="purpleGradient" size="md" text={buttonText} onClick={onButtonClick} fullWidth />
      </Layout>
    );
  }

  return (
    <Layout
      color="gray-25"
      borderRadius={16}
      direction="row"
      justify="space-between"
      align="center"
      paddingX={24}
      paddingY={16}
      marginBottom={24}
      gap={36}
    >
      <Layout direction="column" gap={4} flexGrow={1} flexShrink={1} minWidth={0}>
        {heading && (
          <Text size="body-md" semibold>
            {heading}
          </Text>
        )}
        <Text size="body-sm" color="gray-600">
          {bodyText}
        </Text>
      </Layout>
      <Layout flexShrink={0}>
        <PillButton type="purpleGradient" size="md" text={buttonText} onClick={onButtonClick} />
      </Layout>
    </Layout>
  );
};

export default TenantAdminHelperCtaCard;
